"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
_fontawesomeSvgCore.library.add(_proLightSvgIcons.faAlignLeft, _proLightSvgIcons.faBars, _proLightSvgIcons.faHome, _proLightSvgIcons.faCog, _proLightSvgIcons.faMobile, _proLightSvgIcons.faChevronLeft, _proLightSvgIcons.faChevronRight, _proLightSvgIcons.faChevronUp, _proLightSvgIcons.faChevronDown, _proLightSvgIcons.faEyeSlash, _proLightSvgIcons.faEye, _proLightSvgIcons.faCheck, _proLightSvgIcons.faCheckCircle, _proLightSvgIcons.faTimes, _proLightSvgIcons.faExclamationTriangle, _proLightSvgIcons.faTimesCircle, _proLightSvgIcons.faInfoCircle, _proLightSvgIcons.faFileDownload, _proLightSvgIcons.faRedo, _proLightSvgIcons.faSpinner, _proLightSvgIcons.faAngleDown, _proLightSvgIcons.faAngleUp, _proLightSvgIcons.faLongArrowLeft, _proLightSvgIcons.faPen, _proLightSvgIcons.faListAlt, _proLightSvgIcons.faPlusCircle, _proLightSvgIcons.faLockAlt, _proLightSvgIcons.faSearch, _proLightSvgIcons.faNewspaper, _proLightSvgIcons.faFolder, _proLightSvgIcons.faCalendarDay, _proLightSvgIcons.faBell, _proLightSvgIcons.faUsers, _proLightSvgIcons.faExternalLink, _proLightSvgIcons.faPlus, _proLightSvgIcons.faTrash);
var icons = {
  alignLeft: _proLightSvgIcons.faAlignLeft,
  bars: _proLightSvgIcons.faBars,
  home: _proLightSvgIcons.faHome,
  cog: _proLightSvgIcons.faCog,
  mobile: _proLightSvgIcons.faMobile,
  leftArrow: _proLightSvgIcons.faChevronLeft,
  rightArrow: _proLightSvgIcons.faChevronRight,
  leftCircleArrow: _proLightSvgIcons.faChevronCircleLeft,
  rightCircleArrow: _proLightSvgIcons.faChevronCircleRight,
  eyeClose: _proLightSvgIcons.faEyeSlash,
  eyeOpen: _proLightSvgIcons.faEye,
  check: _proLightSvgIcons.faCheck,
  checkCircle: _proLightSvgIcons.faCheckCircle,
  x: _proLightSvgIcons.faTimes,
  warning: _proLightSvgIcons.faExclamationTriangle,
  close: _proLightSvgIcons.faTimesCircle,
  info: _proLightSvgIcons.faInfoCircle,
  download: _proLightSvgIcons.faFileDownload,
  redo: _proLightSvgIcons.faRedo,
  spinner: _proLightSvgIcons.faSpinner,
  angleDown: _proLightSvgIcons.faAngleDown,
  angleUp: _proLightSvgIcons.faAngleUp,
  chevronLeft: _proLightSvgIcons.faChevronLeft,
  chevronDown: _proLightSvgIcons.faChevronDown,
  chevronUp: _proLightSvgIcons.faChevronUp,
  longArrowLeft: _proLightSvgIcons.faLongArrowLeft,
  pen: _proLightSvgIcons.faPen,
  list: _proLightSvgIcons.faListAlt,
  add: _proLightSvgIcons.faPlusCircle,
  lock: _proLightSvgIcons.faLockAlt,
  sortDown: _proLightSvgIcons.faSortDown,
  sortUp: _proLightSvgIcons.faSortUp,
  search: _proLightSvgIcons.faSearch,
  newsFeed: _proLightSvgIcons.faNewspaper,
  folder: _proLightSvgIcons.faFolder,
  event: _proLightSvgIcons.faCalendarDay,
  alert: _proLightSvgIcons.faBell,
  users: _proLightSvgIcons.faUsers,
  link: _proLightSvgIcons.faExternalLink,
  plus: _proLightSvgIcons.faPlus,
  trash: _proLightSvgIcons.faTrash
};
var Icon = function Icon(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    "data-cy": props.testID,
    icon: icons[props.iconName],
    color: props.color,
    size: props.size || '24px',
    spin: props.spin,
    pulse: props.pulse
  });
};
var _default = Icon;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(icons, "icons", "/Users/crs/WebstormProjects/michelangelo/src/Components/Icon.js");
  reactHotLoader.register(Icon, "Icon", "/Users/crs/WebstormProjects/michelangelo/src/Components/Icon.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Icon.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();